"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAstAppleCampaignNamesResponseSchema = exports.UpdateAstAppleCampaignNamesBodySchema = exports.ListAstAppleCampaignNamesQuerySchema = exports.ListAstAppleCampaignNamesResponseSchema = exports.UpdateAppleSearchTabsRegionBodySchema = exports.CreateAppleSearchTabsRegionBodySchema = exports.ListAppleSearchTabsRegionResponseSchema = exports.GetAppleSearchTabsRegionQuerySchema = exports.UpdateAppleSearchTabsRegionResponseSchema = exports.CreateAppleSearchTabsRegionResponseSchema = exports.GetAppleSearchTabsRegionResponseSchema = exports.AppleSearchTabsRegionResponseSchema = exports.AppleSearchTabsRegionFields = exports.ListAppleSearchTabsChannelResponseSchema = exports.ListAppleSearchTabsChannelQuerySchema = exports.UpdateAppleSearchTabsChannelResponseSchema = exports.CreateAppleSearchTabsChannelResponseSchema = exports.GetAppleSearchTabsChannelResponseSchema = exports.AppleSearchTabsChannelResponseSchema = exports.AppleSearchTabsChannelFields = exports.UpdateAppleSearchTabsChannelBodySchema = exports.CreateAppleSearchTabsChannelBodySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("./common");
/**
 * Channel API Types
 */
exports.CreateAppleSearchTabsChannelBodySchema = (0, core_1.StrictObject)({
    ...common_1.CreateAppleChannelFields,
    structure: ruby_1.ChannelStructureSchema,
});
exports.UpdateAppleSearchTabsChannelBodySchema = (0, core_1.StrictObject)({
    ...common_1.UpdateAppleChannelFields,
});
exports.AppleSearchTabsChannelFields = {
    ...common_1.AppleChannelIdFields,
    ...core_1.ModelMetaFields,
    ...common_1.CreateAppleChannelFields,
    structure: ruby_1.ChannelStructureSchema,
};
exports.AppleSearchTabsChannelResponseSchema = (0, core_1.StrictObject)(exports.AppleSearchTabsChannelFields);
exports.GetAppleSearchTabsChannelResponseSchema = exports.AppleSearchTabsChannelResponseSchema;
exports.CreateAppleSearchTabsChannelResponseSchema = exports.AppleSearchTabsChannelResponseSchema;
exports.UpdateAppleSearchTabsChannelResponseSchema = exports.AppleSearchTabsChannelResponseSchema;
exports.ListAppleSearchTabsChannelQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    status: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleChannelStatusSchema)),
});
exports.ListAppleSearchTabsChannelResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleSearchTabsChannelResponseSchema);
/**
 * Channel region API Types
 */
exports.AppleSearchTabsRegionFields = {
    ...core_1.ModelMetaFields,
    budgetWeighting: core_1.WeightingSchema,
    defaultBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    status: ruby_1.AppleChannelRegionStatusSchema,
    country: core_1.CountrySchema,
    cpdGoal: typebox_1.Type.Optional(core_1.MoneySchema),
    apple: typebox_1.Type.Optional((0, core_1.StrictObject)({
        orgRef: ruby_1.AppleProxyOrgRefSchema,
        campaignRef: ruby_1.AppleProxyRefSchema,
    })),
};
exports.AppleSearchTabsRegionResponseSchema = (0, core_1.StrictObject)(exports.AppleSearchTabsRegionFields);
exports.GetAppleSearchTabsRegionResponseSchema = exports.AppleSearchTabsRegionResponseSchema;
exports.CreateAppleSearchTabsRegionResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleSearchTabsRegionResponseSchema);
exports.UpdateAppleSearchTabsRegionResponseSchema = exports.AppleSearchTabsRegionResponseSchema;
exports.GetAppleSearchTabsRegionQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.ListAppleSearchTabsRegionResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleSearchTabsRegionResponseSchema);
exports.CreateAppleSearchTabsRegionBodySchema = (0, core_1.StrictObject)({
    ...common_1.CreateAppleRegionCommonFields,
});
exports.UpdateAppleSearchTabsRegionBodySchema = (0, core_1.StrictObject)({
    ...common_1.UpdateAppleRegionCommonFields,
});
exports.ListAstAppleCampaignNamesResponseSchema = (0, core_1.createUnsortedListResponseSchema)(common_1.AppleCampaignNameSchema);
exports.ListAstAppleCampaignNamesQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.UpdateAstAppleCampaignNamesBodySchema = (0, core_1.StrictObject)({
    campaignNames: typebox_1.Type.Array(common_1.UpdateAppleCampaignNameSchema),
});
exports.UpdateAstAppleCampaignNamesResponseSchema = (0, core_1.createUnsortedListResponseSchema)(common_1.AppleCampaignNameSchema);
